export enum PaymentGatwayEnum {
  AMAZON_PAY = 7,
  STRIPE = 8,
  CHECKOUT = 9
}
